const RECEIVE_DEALS = "RECEIVE_DEALS";
const SWITCH_DEAL_VIEW = "SWITCH_DEAL_VIEW";
const CHECKBOX_CLICK = "CHECKBOX_CLICK";
const PAGE_LOADING = "PAGE_LOADING";
const CLEAR_DEALS_STATE = "CLEAR_DEALS_STATE";
const SET_DEALS_PAGE = "SET_DEALS_PAGE";
const SET_DEALS_SORT = "SET_DEALS_SORT";
const SET_DEALS_FILTER = "SET_DEALS_FILTER";

export default {
    RECEIVE_DEALS,
    SWITCH_DEAL_VIEW,
    CHECKBOX_CLICK,
    PAGE_LOADING,
    CLEAR_DEALS_STATE,
    SET_DEALS_PAGE,
    SET_DEALS_SORT,
    SET_DEALS_FILTER,
};
